// extracted by mini-css-extract-plugin
export default {"container":"jl-z","disabled":"kl-z","subtotal":"ll-z","legal":"ml-z"};